import rnCore from 'rhino/src/core/core.module';
import * as rnApplication from './application.service';
import * as rnApplicationView from './application-view.service';

export default angular.module('rhino.components.application', [
  rnCore,
  'rhino.components.locale',
])
  .service(rnApplication.name, rnApplication.default)
  .service(rnApplicationView.name, rnApplicationView.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/application/application.module.js